import { MarkovGroup } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setMarkovGroupList = (groupList: types.MarkovGroupList) => ({
    type: inferLiteral(types.MARKOV_GROUP_LIST),
    groupList,
})
export const setMarkovGroupIds = (groupIds: readonly number[]) => ({
    type: inferLiteral(types.MARKOV_GROUP_IDS),
    groupIds,
})
export const setMarkovGroupEdit = (group: MarkovGroup) => ({
    type: inferLiteral(types.MARKOV_GROUP_EDIT),
    group,
})
export const setMarkovGroupSort = (sortColumn: keyof MarkovGroup, sortOrder: OrderType) => ({
    type: inferLiteral(types.MARKOV_GROUP_SORT),
    sortColumn,
    sortOrder,
})
export const setMarkovGroupFilters = (filters: types.MarkovGroupFilters) => ({
    type: inferLiteral(types.MARKOV_GROUP_FILTERS),
    filters,
})
export const setMarkovGroupReloadList = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_GROUP_RELOAD_LIST),
    value,
})
export const setMarkovGroupReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_GROUP_RELOAD_EDIT),
    value,
})
